/**
 * Get the amount formatted according to the current locale and exactly 3 decimal places
 *
 * @param {number} amount - The amount to format
 * @param {string} locale - The locale to format the amount
 * @returns {string}
 */
export const getAmountFormatted = (amount, locale = "de-DE", digits = 3) => {
  const formatOptions = { minimumFractionDigits: digits, maximumFractionDigits: digits }
  return new Intl.NumberFormat(locale, formatOptions).format(amount)
}

/**
 * Get number formatted in percent
 *
 * @param {number|string} number - The number to format
 * @param {string} locale - The locale to format the number (default: "de-DE")
 * @returns {string|null} - The formatted number in percent or null if the input is not a number or string
 */
export function getNumberFormattedInPercent(number, locale = "de-DE") {
  if (typeof number !== "string" && typeof number !== "number") return number
  return Number(number / 100).toLocaleString(locale, {
    style: "percent",
    minimumFractionDigits: 2,
  })
}

/**
 * Takes fraction of digits value and converts it to euro value
 *
 * @param {{fractionDigits: number, price: number}}
 *
 * @returns {number}
 */
export const applyFractionDigitsPrice = ({ fractionDigits, price }) => {
  return Number(price) / Math.pow(10, Number(fractionDigits))
}

/**
 * Rounds the value to 2 decimal digits
 *
 * @param {number|string} value
 *
 * @returns {number}
 */
export const applyRounding = (value) => {
  return +(Math.round(Number(value) + "e+2") + "e-2")
}
